module.exports = __webpack_public_path__ + "static/media/warning.015fc846.png";